const ja_JP = {
  'android': `Android`,
  'contact_us': `お問い合わせ`,
  'cookie_accept_all': `すべての Cookie を受け入れる`,
  'cookie_accept_selected': `選択内容を確認する`,
  'cookie_learn_more': ` `,
  'cookie_settings': `Cookie 設定`,
  'cookie_settings_desc': `このウェブサイトの機能性、トラフィックの分析、パーソナリゼーション表示、ソーシャルメディア機能、広告のためにCookieを利用しています。Cookie Noticeのページにて詳しい説明、Cookieに同意しない場合の設定変更方法などをご覧いただけます。`,
  'cookie_toggle_required': `厳密に必要な Cookie`,
  'cookie_toggle_required_desc': `この Cookie はウェブサイトが正常に機能するために必要なもので、利用者のシステム内でスイッチをオフにすることはできません。これらは通常、プライバシー設定、ログイン、フォームへの入力など、サービスのリクエストに相当するユーザーのアクションに応じてのみ設定されます。この Cookie をブロック/警告するようにブラウザを設定することは可能ですが、サイトの一部が機能しなくなります。この Cookie が個人を特定できる情報を保存することはありません。`,
  'cookie_toggle_performance': `パフォーマンス Cookie`,
  'cookie_toggle_performance_desc': `この Cookie により訪問者数と通信トラフィックソースがカウントできるようになり、弊社サイトのパフォーマンスを判断し改善する際に役立ちます。最も人気があるページ、人気が低いページを確認したり、訪問者がサイト内をどのように移動するかを理解するのに役立ちます。これらの Cookie が収集するすべての情報はひとつにまとめられるので、匿名性が保たれています。この Cookie を受け入れなければ、利用者が弊社サイトを訪問しても、弊社にはわかりません。`,
  'copyright_statement': `Copyright © 2023 Trend Micro Incorporated. All rights reserved.`,
  'device_detail': `携帯端末の詳細`,
  'expired_on': `有効期限終了: `,
  'expires_on': `有効期限: `,
  'help_center': `ヘルプとサポート`,
  'ios': `iOS`,
  'label_alarm': `アラーム`,
  'label_locate': `携帯端末の捜索`,
  'label_lock': `リモートロック`,
  'label_lost_device_protection': `盗難/紛失時の対策`,
  'label_reset': `その他`,
  'label_trend_micro': `トレンドマイクロ`,
  'label_wipe': `リモート消去`,
  'landing_page_android_only': `Androidのみ`,
  'landing_page_description': `紛失した携帯端末を簡単に捜索、ロック、またはデータ消去できます。{br}(携帯端末により利用できる機能が異なります)`,
  'landing_page_description_main_function': `盗難/紛失時に携帯端末を守ります。`,
  'landing_page_download_from': `トレンドマイクロのアプリのダウンロード:`,
  'landing_page_finditnow': `今すぐ探す`,
  'landing_page_locate': `携帯端末の捜索`,
  'landing_page_locate_description': `場所や時間を問わずお使いの携帯端末を捜索します。`,
  'landing_page_lock': `リモートロック`,
  'landing_page_lock_description': `紛失した携帯端末を他者が使用できないようにします。`,
  'landing_page_alarm': `リモートアラーム`,
  'landing_page_alarm_description': `リモートコントロールでアラームを1分間鳴らします。`,
  'landing_page_title': `盗難/紛失時の対策Web`,
  'landing_page_wipe': `リモート消去`,
  'landing_page_wipe_description': `紛失した携帯端末に保存されているすべてのデータを消去します。`,
  'license_day': `日`,
  'license_days': `日`,
  'license_expired': `契約の期限終了`,
  'license_vaild_subscription': `有効なライセンスです`,
  'location_not_found': `場所が検出されませんでした`,
  'map_no_device': `No device protected! To locate a device, install protection now.`,
  'policies_privacy': `プライバシーポリシー`,
  'sign_in': `ログイン`,
  'sign_out': `ログアウト`,
  'test_temp_locale': `Test`,
  'trendmicrocom': `トレンドマイクロ`,
  'unlock_key': `ロック解除キー:`,
  'unlock_key_wording': `このキーを使用して携帯端末のロックを解除します。`,
  // tmpn success message
  'message_alarm_success': `{0}でアラームを鳴らしています`,
  'message_locate_success': `{0}の場所を更新しています`,
  'message_lock_success': `{0}がロックされました`,
  'message_wipe_success': `{0}のすべてのデータが消去されました`,
  // tmpn POST command error
  "error_alarm": `{0}でアラームを鳴らすことができません`,
  "error_locate": `{0}が見つかりません`, 
  "error_lock": `{0}をロックできません`, 
  "error_wipe": `{0}のデータを削除できません`, 
  // tmpn GET command error
  'error_alarm_CS001': `Cannot access your device through the Internet.`,
  'error_alarm_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS001': `Cannot access your device through the Internet.`,
  'error_locate_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS004': `Unable to display the location because GPS on mobile device is disabled.`,
  'error_lock_CS001': `Cannot access your device through the Internet.`,
  'error_lock_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_wipe_CS001': `Cannot access your device through the Internet.`,
  'error_wipe_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_default': `処理できません。`,
  // product name
  'product_name_IS10': `Trend Micro& ™ Mobile Security for iOS`,
  'product_name_IS11': `ウイルスバスター モバイル`,
  'product_name_IS12': `ウイルスバスター モバイル`,
  'product_name_IS13': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_IS14': `iOS 版的安全達人`,
  'product_name_IS27': `Trend Micro™ Mobile Security for iOS`,
  'product_name_ISM0': `ウイルスバスター モバイル OKAERI`,
  'product_name_ISM1': `ウイルスバスター モバイル OKAERI`,
  'product_name_MS20': `ウイルスバスターモバイル 月額版`,
  'product_name_MS21': `ウイルスバスター モバイル`,
  'product_name_MS23': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS24': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS25': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS26': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS27': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS29': `リモートアラーム`,
  'product_name_MS30': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS31': `ウイルスバスターモバイル for Android 月額版`,
  'product_name_MS33': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_MS34': `Android™ 版的安全達人`,
  'product_name_MS36': `ウイルスバスター™ モバイル meets ハローキティ`,
  'product_name_MSM0': `ウイルスバスター モバイル OKAERI`,
  'product_name_MSM1': `ウイルスバスター モバイル OKAERI`,
};

export default ja_JP;
